import axiosPost from '../axiosPost';
import { UserCredentialsType } from '../../../types/types';
import { AxiosPostBody } from '../../../types/AxiosPost';

type Args = UserCredentialsType & {
    "merchantId": number
    "fechaDesde": string
    "fechaHasta": string
    "monedaCod": string
};


export const MWSaldoGet = async (arg: Args) => {
    const body: AxiosPostBody = {
        "service": "MWSaldoGet",
        "params": {
            "merchantId": arg.merchantId,
            "fechaDesde": arg.fechaDesde,
            "fechaHasta": arg.fechaHasta,
            "monedaCod": arg.monedaCod
        }
    }

    try {
        const result = await axiosPost('Y', body, arg);
        
        return result.result
    } catch (err) {
        console.log(err)
    }
}